import React from 'react'
import { Pie } from 'react-chartjs-2';
import {Chart, ArcElement} from 'chart.js'
Chart.register(ArcElement);


const PieChart = () => {
  return (
    <div className='h-36'>
    <Pie data={{datasets: [
        {
          label: '# of votes',
          data: [12, 13,4],
          backgroundColor:[
              'red',
              'blue',
              'yellow'
          ]
        },
      ],
    }} />
  </div>
  )
}

export default PieChart